export default __webpack_public_path__ + "static/media/logo.bcff4745.png";